var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.64062C0 4.5 5.5 0 5.5 0C5.5 0 7.51562 1.85313 8.26875 2.79375C8.6125 2.34375 9.75 1.45312 9.75 1.45312C9.75 1.45312 14 4.99687 14 8.6375C14 12.6313 10.8813 16 7 16C3.075 16 0 12.6281 0 8.64062ZM7.05312 13C7.84375 13 8.54375 12.7812 9.20312 12.3438C10.5188 11.425 10.8719 9.5875 10.0813 8.14375C9.99375 7.96875 9.90625 7.79375 9.775 7.61875L8.19375 9.45625C8.19375 9.45625 5.65 6.21875 5.47188 6C4.15938 7.61875 3.5 8.5375 3.5 9.5875C3.5 11.7312 5.08125 13 7.05312 13Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.b91d631fcd2bf9ffbf50d41ef53227df.svg";
export { ForwardRef as ReactComponent };